export default "__VITE_ASSET__Cl1JwP_E__"